import React, { useState } from 'react';
import { IconPlus, IconSearch, IconGrid, IconGrip } from './Icons';
import './Suppliers.css';

export default function Suppliers() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [columnMenuOpen, setColumnMenuOpen] = useState(false);

  const COLUMNS = [
    { key: 'name', label: 'Name' },
    { key: 'contact', label: 'Contact' },
    { key: 'phone', label: 'Phone' },
    { key: 'email', label: 'Email' },
    { key: 'country', label: 'Country' },
    { key: 'note', label: 'Note' },
  ];

  const [visibleColumns, setVisibleColumns] = useState(
    COLUMNS.reduce(
      (acc, col) => ({
        ...acc,
        [col.key]: true,
      }),
      {},
    ),
  );

  const toggleColumn = (key) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const activeColumns = COLUMNS.filter((col) => visibleColumns[col.key] !== false);
  const activeColumnCount = activeColumns.length + 1; // +1 for actions column

  return (
    <div className="suppliers-page">
      <div className="suppliers-card">
        <div className="suppliers-header-row">
          <h1 className="suppliers-title">Suppliers</h1>
          <button
            type="button"
            className="suppliers-header-btn suppliers-header-btn-primary"
            onClick={() => setShowAddModal(true)}
          >
            <IconPlus />
            Add Supplier
          </button>
        </div>

        <div className="suppliers-filters-row">
          <div className="suppliers-filters-left">
            <div className="suppliers-column-toggle-wrap">
              <button
                type="button"
                className="suppliers-select-toggle suppliers-column-toggle"
                aria-label="Choose visible columns"
                onClick={() => setColumnMenuOpen((open) => !open)}
              >
                <span className="suppliers-column-dots">●●●</span>
              </button>

              {columnMenuOpen && (
                <div className="suppliers-column-menu">
                  {COLUMNS.map((col) => (
                    <button
                      key={col.key}
                      type="button"
                      className={`suppliers-column-menu-item${
                        visibleColumns[col.key] !== false ? ' active' : ''
                      }`}
                      onClick={() => toggleColumn(col.key)}
                    >
                      <span>{col.label}</span>
                      {visibleColumns[col.key] !== false && (
                        <span className="suppliers-column-check">✓</span>
                      )}
                    </button>
                  ))}
                  <div className="suppliers-column-menu-divider" />
                  <div className="suppliers-column-menu-footer">
                    <IconGrip />
                  </div>
                </div>
              )}
            </div>

            <button
              type="button"
              className="suppliers-layout-toggle"
              aria-label="Layout options"
            >
              <IconGrid />
            </button>
          </div>

          <div className="suppliers-filters-right">
            <button type="button" className="suppliers-utility-btn">
              Excel
            </button>
            <div className="suppliers-search">
              <input type="text" placeholder="Search" aria-label="Search suppliers" />
              <span className="suppliers-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="suppliers-table-wrapper">
          <table className="suppliers-table">
            <thead>
              <tr>
                {activeColumns.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="suppliers-table-empty" colSpan={activeColumnCount}>
                  No record found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="suppliers-footer-row">
          <div className="suppliers-footer-left">
            <select
              className="suppliers-page-size"
              defaultValue="10"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            <span>0-0 / 0</span>
          </div>
          <div className="suppliers-footer-right">
            <button
              type="button"
              className="suppliers-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="suppliers-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Add Supplier</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowAddModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Company name</div>
                <input
                  className="estimates-form-input"
                  placeholder="Company name"
                />

                <div className="estimates-form-label">Name</div>
                <input className="estimates-form-input" placeholder="Name" />

                <div className="estimates-form-label">Phone</div>
                <input className="estimates-form-input" placeholder="Phone" />

                <div className="estimates-form-label">Email</div>
                <input className="estimates-form-input" placeholder="Email" />

                <div className="estimates-form-label">Country</div>
                <input className="estimates-form-input" placeholder="Country" />

                <div className="estimates-form-label">Address</div>
                <textarea
                  className="estimates-form-textarea"
                  placeholder="Address"
                />

                <div className="estimates-form-label">Note</div>
                <textarea
                  className="estimates-form-textarea"
                  placeholder="Note"
                />

                <div className="estimates-form-label">Bank Details</div>
                <textarea
                  className="estimates-form-textarea"
                  placeholder="Bank Details"
                />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowAddModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

